import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

import SelectPeopleType from './SelectPeopleType'
import OrganisationCode from './OrganisationCode'
import DataTable from 'components/organisms/DataTable'
import SearchField from 'components/atoms/SearchField'
import PaginationControl from 'components/organisms/PaginationControl'

import { peopleColumns } from './'

export const styles = theme => ({
  root: {},
  header: {
    marginTop: theme.spacing(4),
  },
  table: {
    margin: `${theme.spacing(6)}px 0`,
  },
})

const PeopleOverview = ({
  users,
  classes,
  filters,
  tableLoading,
  onPageChange,
  selectedPeople,
  onFilterChange,
  onSearchChange,
  onTableRowClick,
  onGenerateClick,
  onCodeCopyClick,
  onTableSortClick,
  organisationCode,
  onDeactivateClick,
  onTableSelectableClick,
  organisationCodeHasLoaded,
}) => (
  <div className={classes.root}>
    <OrganisationCode
      data={organisationCode}
      onCodeCopy={onCodeCopyClick}
      onGenerateClick={onGenerateClick}
      onDeactivateClick={onDeactivateClick}
      dataLoaded={organisationCodeHasLoaded}
    />
    <Grid className={classes.header} justify="space-between" container>
      <Grid item>
        <SelectPeopleType
          onChange={onFilterChange}
          activeFilter={filters.filter}
        />
      </Grid>
      <Grid item>
        <SearchField onChange={onSearchChange} />
      </Grid>
    </Grid>
    <DataTable
      key="People table"
      dataProvider={users}
      columns={peopleColumns}
      className={classes.table}
      tableLoading={tableLoading}
      onRowClick={onTableRowClick}
      onSortClick={onTableSortClick}
      rowComponentProps={{
        selectedItemKey: 'id',
        selectedItems: selectedPeople,
      }}
      onSelectableClick={onTableSelectableClick}
      emptyStateTitle="It’s pretty quiet here without contributors"
      // eslint-disable-next-line max-len
      emptyStateDescription="Share an invite code with Goodnature Chirp App users so they can share traps with you and help maintain them. Once you generate a code you will need to copy it and share it via email or phone so they can enter it within the Goodnature Chirp App"
    />
    <PaginationControl
      pagination={filters.pagination}
      onPageChange={onPageChange}
    />
  </div>
)

PeopleOverview.propTypes = {
  data: PropTypes.object,
  users: PropTypes.object,
  classes: PropTypes.object,
  filters: PropTypes.object,
  onPageChange: PropTypes.func,
  tableLoading: PropTypes.bool,
  onFilterChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  selectedPeople: PropTypes.array,
  onCodeCopyClick: PropTypes.func,
  onTableRowClick: PropTypes.func,
  onGenerateClick: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onDeactivateClick: PropTypes.func,
  organisationCode: PropTypes.object,
  onTableSelectableClick: PropTypes.func,
  organisationCodeHasLoaded: PropTypes.bool,
}

export default withStyles(styles)(PeopleOverview)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleOverview/PeopleOverview.js